<template>
  <img v-if="image" class="inline-block rounded-md" :src="image" alt="" />
  <span v-else class="inline-block overflow-hidden rounded-md bg-slate-100">
    <svg class="h-full w-full text-slate-300" fill="currentColor" viewBox="0 0 24 24">
      <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
    </svg>
  </span>
</template>

<script lang="ts" setup>
defineProps({
  image: {
    type: String,
    default: null
  }
})
</script>
